(() => {
  'use strict';
  const filterURL = new URL(location.href);
  const filterPath = filterURL.pathname.match(/^(.*\/collections\/[^/]+)\/([^/]+)\/?$/);
  const tagSegment = filterPath ? decodeURIComponent(filterPath[2]) : '';
  const lastTag = tagSegment.split('+').filter(Boolean).at(-1);
  const colorFamilies = {"color-blue-light":"color-blue","color-blue-dark":"color-blue","color-green-light":"color-green","color-green-medium":"color-green","color-green-dark":"color-green","color-pink-medium":"color-red","color-pink":"color-red","color-red-medium":"color-red","color-red-dark":"color-red","color-purple-light":"color-purple","color-purple-medium":"color-purple","color-purple-dark":"color-purple","color-earth-medium":"color-earth","color-earth-dark":"color-earth","color-monochrome-light":"color-monochrome","color-monochrome-medium":"color-monochrome","color-monochrome-dark":"color-monochrome","color-multicolor-light":"color-multicolor","color-multicolor-medium":"color-multicolor"};
  const canonicalTag = colorFamilies[lastTag] || lastTag;
  if (filterPath && canonicalTag && canonicalTag !== tagSegment) {
    filterURL.pathname = filterPath[1] + '/' + encodeURIComponent(canonicalTag);
    filterURL.searchParams.delete('page');
    location.replace(filterURL.pathname + filterURL.search);
    return;
  }
  document.querySelectorAll('.tf-filter-tag-list a,.active-pills .pill a').forEach(link => {
    const target = new URL(link.href);
    const current = new URL(location.href);
    for (const key of new Set(current.searchParams.keys())) {
      if (key !== 'page' && !target.searchParams.has(key)) {
        current.searchParams.getAll(key).forEach(value => target.searchParams.append(key, value));
      }
    }
    link.href = target.pathname + target.search;
  });
})();
